import language from "./../../common/dictionary";
import cookie from "./../templates/cookie.dust";
import { CLICKED_COOKIEACCEPT } from "./../../common/analytics/analyticsevents";
import { COOKIE_MORE_INFO } from "./../utilities/redirectorKeys";
import APIManager from "./../utilities/apimanager";

/**
 * Contstructs the Cookie view
 */
export default class Cookie {
  appState = null;
  DOMContainer = null;
  cookieManager = null;
  options = null;

  constructor(appState, DOMContainer, cookieManager, options) {
    this.appState = appState;
    this.DOMContainer = DOMContainer;
    this.cookieManager = cookieManager;
    this.options = options;

    // coockie warning when the cookie_info_cookie_name is defined
    if (this.options.cookie_info_cookie_name) {
      const fetchedString = this.cookieManager.getCookie(
        this.options.cookie_info_cookie_name
      );
      if (typeof fetchedString !== "undefined") {
        // cookie is allready accepted -> dont show cookie
      } else {
        this.showCookie();
      }
    }
  }

  showCookie() {
    if (this.DOMContainer !== null) {
      //create context
      const context = {};
      context.text = language.CookieInformText;
      context.text_link = language.CookieLinkText;
      context.button = language.CookieConfirmButton;
      APIManager.getRedirectorUrl(
        COOKIE_MORE_INFO,
        this.appState.buildVersion,
        this.appState.userId,
        this.appState.downloadToken
      )
        .then((result) => {
          context.link = result;
        })
        .catch(() => {
          context.link = null;
        })
        .then(() => {
          Dust.render(cookie, context, (err, result) => {
            this.DOMContainer.innerHTML = result;
            this.attatchClickHandlers();
          });
        });
    }
  }

  attatchClickHandlers() {
    const cookieConfirm = document.querySelector(".cookie-confirm");
    if (cookieConfirm !== null) {
      cookieConfirm.addEventListener("click", () => {
        this.confirmedCookie();
      });
    }
  }

  confirmedCookie() {
    $(".cookie-container").hide();
    this.cookieManager.createCookie(this.options.cookie_info_cookie_name, true);
    this.appState.triggerEvent(CLICKED_COOKIEACCEPT);
  }
}



// WEBPACK FOOTER //
// ./src/common/components/cookieComponent.js